import React from "react";
import "../../pages/style.css";
import ProjectCard from "./ProjectCard";
import { Container, Row, Col } from "react-bootstrap";
import Resumebuilder from "../../Assets/resume.png";
import Htmlportfolio from "../../Assets/portfolio.png";
import TodoHtml from "../../Assets/TodoHtml.png";
import Invoicegenerator from "../../Assets/invoice-generator.png";
import Calc from "../../Assets/calc-ui.png";
import BlogApi from "../../Assets/Blog-API.png";

function Projectlist() {
  return (
    <div className="projectbackground">
      <Container fluid className="project-section">
        <Container>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={Resumebuilder}
                isBlog={false}
                title="Resume Builder"
                description="The Resume Builder with ReactJS, React-Bootstrap, and MUI is a web-based application that allows users to create professional resumes. It is built using the ReactJS library and React-Bootstrap and MUI for styling and formatting. The application is designed to be user-friendly, with a modern and responsive design that adapts to different screen sizes. It offers a variety of templates and customization options to help users create unique and compelling resumes."
                ghLink="https://loginlogout-3ae55.web.app/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={BlogApi}
                isBlog={false}
                title="Blog with API"
                description="The blog site with ReactJS and API handle is a web-based application that allows users to see the blog posts. It is built using the ReactJS library and an API for handling backend functionality. The application is designed to be scalable and responsive, with a user-friendly interface that allows users to see the blog posts."
                ghLink="https://blogpagal.web.app/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={Htmlportfolio}
                isBlog={false}
                title="Html Portfolio"
                description="The portfolio site with HTML and JavaScript is a web-based application that showcases the work and accomplishments of an individual or a company. It is built using HTML and JavaScript, and provides an easy-to-use interface for presenting information about the portfolio owner or the company. The application is designed to be visually appealing and user-friendly, with a modern and responsive design that adapts to different screen sizes."
                ghLink="https://lavkush-maurya.github.io/Portfolio/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={TodoHtml}
                isBlog={false}
                title="Todo Html"
                description="The todo list with HTML and JavaScript is a simple web-based application that allows users to create and manage a list of tasks that they need to complete. The application is built using HTML and JavaScript, and provides an easy-to-use interface for adding, editing, and deleting tasks. It is designed to be lightweight and accessible to a wide range of users."
                ghLink="https://lavkush-maurya.github.io/todo-with-javascript/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={Invoicegenerator}
                isBlog={false}
                title="Invoice Generator"
                description="The invoice generator with ReactJS is a web-based application that allows users to easily generate and manage invoices. It is built using the ReactJS library, which provides a robust and efficient framework for developing dynamic user interfaces. The application is designed to be intuitive and user-friendly, with a clean and modern interface."
                ghLink="https://invoice-generator2023.web.app/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={Calc}
                isBlog={false}
                title="Calc"
                description="The calculator UI with HTML and CSS is a web-based application that provides a simple calculator interface for performing basic arithmetic operations. It is built using HTML and CSS, two programming languages commonly used for developing web applications. The application is designed to be user-friendly and intuitive, with a clean and modern interface that is easy to navigate."
                ghLink="https://lavkush-maurya.github.io/calc-ui/"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
export default Projectlist;
